import webservice from '../../utils/webservice'
const state = {
  cars: {}
}

// noinspection JSUnusedGlobalSymbols
const getters = {
  getCars: (state) => {
    return state.cars
  },
  getCarData: (state) => (carId) => {
    if (state.cars.hasOwnProperty(carId)) {
      return state.cars[carId]
    } else {
      return null
    }
  }
}

const actions = {
  fetchAnalyticsForDailyPeriodicityOfCars (store, payload) {
    // console.log(store.state.analytics.cars.length)
    return webservice.analytics.visualizationsFromCarsArray(payload.cars, payload.periodicity).then(results => {
      results.forEach(carData => {
        store.commit('setCarData', {periodicity: payload.periodicity, carData})
      })
    })
  },

  syncCarfactoryDealerQuota ({commit}) {
    return webservice.dealer.findCarfactoryQuota().then(quota => {
      if (quota !== null) {
        commit('setCarfactoryDealerQuota', quota)
      }
    }).catch()
  }
}

// noinspection JSUnusedGlobalSymbols
const mutations = {
  setCarData (state, data) {
    let carId = data.carData.carId
    if (!state.cars.hasOwnProperty(carId)) {
      state.cars[carId] = {
        id: carId
      }
      state.cars[carId][data.periodicity] = { rawData: [], accumulated: [] }
    }

    state.cars[carId][data.periodicity].accumulated.push(data.carData.visualizations)

    state.cars[carId][data.periodicity].rawData.push({
      visualizations: data.carData.visualizations,
      timestamp: data.carData.timestamp,
      date: data.carData.date
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js